import { UsersLogicService } from '../logic-services';

/**
 * Application initializer that loads authentication data from sessionStorage
 * before the application starts routing. This ensures authUser is available
 * for all guards and components on page refresh.
 */
export function initializeAuth(usersLogicService: UsersLogicService): () => void {
    return () => {
        usersLogicService.init();
    };
}
